var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _ellipse2, _path7, _ellipse3, _path8, _ellipse4, _path9, _ellipse5, _path10, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18684 1.3999H2V5.76951",
    stroke: "#888888",
    strokeWidth: 2.17001,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8132 18.5664L18 18.5664L18 14.1968",
    stroke: "#888888",
    strokeWidth: 2.17001,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.1968L2 18.5664L6.18684 18.5664",
    stroke: "#888888",
    strokeWidth: 2.17001,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.76951L18 1.3999L13.8132 1.3999",
    stroke: "#888888",
    strokeWidth: 2.17001,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4094 6.57519C14.4094 7.70956 12.4147 10.651 12.4147 10.651C12.4147 10.651 10.4199 7.70956 10.4199 6.57519C10.4199 5.44083 11.313 4.52124 12.4147 4.52124C13.5163 4.52124 14.4094 5.44083 14.4094 6.57519Z",
    fill: "#888888"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4679,
    cy: 6.54515,
    rx: 0.831137,
    ry: 0.86742,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4094 6.57519C14.4094 7.70956 12.4147 10.651 12.4147 10.651C12.4147 10.651 10.4199 7.70956 10.4199 6.57519C10.4199 5.44083 11.313 4.52124 12.4147 4.52124C13.5163 4.52124 14.4094 5.44083 14.4094 6.57519Z",
    fill: "#888888"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4679,
    cy: 6.54515,
    rx: 0.831137,
    ry: 0.86742,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4094 6.57519C14.4094 7.70956 12.4147 10.651 12.4147 10.651C12.4147 10.651 10.4199 7.70956 10.4199 6.57519C10.4199 5.44083 11.313 4.52124 12.4147 4.52124C13.5163 4.52124 14.4094 5.44083 14.4094 6.57519Z",
    fill: "#888888"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4679,
    cy: 6.54515,
    rx: 0.831137,
    ry: 0.86742,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4094 6.57519C14.4094 7.70956 12.4147 10.651 12.4147 10.651C12.4147 10.651 10.4199 7.70956 10.4199 6.57519C10.4199 5.44083 11.313 4.52124 12.4147 4.52124C13.5163 4.52124 14.4094 5.44083 14.4094 6.57519Z",
    fill: "#888888"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4679,
    cy: 6.54515,
    rx: 0.831137,
    ry: 0.86742,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4094 6.57519C14.4094 7.70956 12.4147 10.651 12.4147 10.651C12.4147 10.651 10.4199 7.70956 10.4199 6.57519C10.4199 5.44083 11.313 4.52124 12.4147 4.52124C13.5163 4.52124 14.4094 5.44083 14.4094 6.57519Z",
    fill: "#888888"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.4679,
    cy: 6.54515,
    rx: 0.831137,
    ry: 0.86742,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91101 11.9187C8.91101 13.0041 7.00238 15.8185 7.00238 15.8185C7.00238 15.8185 5.09375 13.0041 5.09375 11.9187C5.09375 10.8333 5.94827 9.95337 7.00238 9.95337C8.05648 9.95337 8.91101 10.8333 8.91101 11.9187Z",
    fill: "#888888"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.05307,
    cy: 11.89,
    rx: 0.795262,
    ry: 0.829978,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoZones);
export default __webpack_public_path__ + "static/media/geoZones.bc71c56e2d7bb0ab905e5831b4989041.svg";
export { ForwardRef as ReactComponent };